import { dateFormat } from "@/helpers/dateFormat";
import { ResultPagDTO } from "@/interfaces/base-dto";
import { AcompanhamentoPacienteFiltroDTO } from "@/interfaces/dashboard";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function getBusinessUnitsDashboard(): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.BUSINESS_UNIT_DASHBOARD),
    ).pipe(map((r: any) => r.data || {}));
}

export function getProductionPrescriptionChartData(filters: any): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.PRODUCTION_PRESCRIPTION_CHART_DATA, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function getUsersTranscriptionChartData(filters: any): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.USERS_TRANSCRIPTION_CHART_DATA, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function getUsersWrongTranscriptionChartData(filters: any): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.USERS_WRONG_TRANSCRIPTION_CHART_DATA, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function getUsersApprovalChartData(filters: any): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.USERS_APPROVAL_CHART_DATA, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function getStatusPrescriptionChartData(filters: any): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.STATUS_PRESCRIPTION_CHART_DATA, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function getNewLostPatientChartData(filters: any): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.NEW_LOST_PATIENT_CHART_DATA, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function getPatientsPrescriptionsMonitoringData(filters: AcompanhamentoPacienteFiltroDTO, autoRefresh: boolean): Observable<ResultPagDTO<any>> {
    return from(
        apiClient.get(ENDPOINTS.DASHBOARD_PATIENTS_PRESCR_MONITORING + (autoRefresh ? '/auto-refresh' : ''), filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function getPatientsPrescriptionsMonitoringDayData(idPatient: number, day: any, idPrescription: number): Observable<any> {
    return from(
        apiClient.get(`${ENDPOINTS.DASHBOARD_PATIENTS_PRESCR_MONITORING}/${idPatient}`, { data: dateFormat(day, "ISO-DATE"), idPrescricao: idPrescription ? idPrescription : null }),
    ).pipe(map((r: any) => r.data || {}));
}